import { render } from "./formgroup.vue?vue&type=template&id=653a097e"
import script from "./formgroup.vue?vue&type=script&lang=js"
export * from "./formgroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__